export const DEFAULT_PRODUCT_IMAGE = '/assets/imgs/theme/product-placeholder.svg';

export const isMissingProductImage = (imageUrl) => !String(imageUrl || '').trim();

export const resolveProductImageUrl = (imageUrl) => {
  const raw = String(imageUrl || '').trim();
  if (!raw) return DEFAULT_PRODUCT_IMAGE;
  return raw;
};

export const withProductImageFallback = (imageUrl, fallbackUrl = DEFAULT_PRODUCT_IMAGE) => {
  const raw = String(imageUrl || '').trim();
  if (!raw) return fallbackUrl;
  return raw;
};
